import type { AdapterMeta } from "@repo/adapter-core";

export const PETRUSMA_PROPERTY_META: AdapterMeta = {
  slug: "petrusma-property",
  name: "Petrusma Property",
  baseUrl: "https://www.petrusma.com.au",
  description: "Hobart and Southern Tasmania specialist with residential sold property coverage.",
  supportedStates: ["TAS"],
  urlPattern: /petrusma\.com\.au\/property\/[a-z0-9-]+/i,
  sourceType: "agency",
};
